/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for starting the time slot's examination with an explicit admission set.

Deprecated name, retired 2026-09-22: ``OralExamStartCohortRequest``.
 */
export interface OralExamStartTimeSlotRequest {
  admittedBookingIds: string[];
  partialStart?: boolean;
}
